const MedalIcon = ({size}) => {
  const width = size ? size : "21"
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.625 5.36056C2.625 4.87697 2.625 4.63517 2.66253 4.43373C2.82891 3.5407 3.52245 2.84211 4.40903 2.67452C4.60902 2.63672 4.84907 2.63672 5.32917 2.63672H15.6708C16.1509 2.63672 16.391 2.63672 16.591 2.67452C17.4776 2.84211 18.1711 3.5407 18.3375 4.43373C18.375 4.63517 18.375 4.87697 18.375 5.36056C18.375 5.83502 18.375 6.07224 18.3474 6.29222C18.227 7.25271 17.7198 8.12105 16.9447 8.69353C16.7672 8.82465 16.5613 8.93986 16.1495 9.17027L13.8995 10.4294C12.2378 11.3593 11.4069 11.8242 10.5 11.8242C9.59306 11.8242 8.76221 11.3593 7.1005 10.4294L4.85046 9.17027C4.4387 8.93986 4.23283 8.82465 4.05532 8.69353C3.28024 8.12105 2.773 7.25271 2.65258 6.29222C2.625 6.07224 2.625 5.83502 2.625 5.36056Z"
        stroke="#A2A2A2"
        stroke-width="0.967742"
        stroke-linecap="round"
      />
      <path
        d="M7 5.26172V6.13672M10.5 5.26172V7.88672M14 5.26172V6.13672"
        stroke="#A2A2A2"
        stroke-width="0.967742"
        stroke-linecap="round"
      />
      <path
        d="M11.1803 12.8313L11.8732 14.2286C11.9677 14.4232 12.2196 14.6097 12.4322 14.6454L13.6882 14.8558C14.4913 14.9908 14.6803 15.5783 14.1016 16.1579L13.1252 17.1423C12.9598 17.309 12.8693 17.6306 12.9204 17.8608L13.2 19.0795C13.4204 20.0441 12.9126 20.4172 12.0661 19.9131L10.8889 19.2105C10.6763 19.0835 10.3259 19.0835 10.1094 19.2105L8.93219 19.9131C8.08966 20.4172 7.57784 20.0401 7.79832 19.0795L8.07785 17.8608C8.12903 17.6306 8.03848 17.309 7.87312 17.1423L6.89673 16.1579C6.32192 15.5783 6.50696 14.9908 7.31012 14.8558L8.56605 14.6454C8.77471 14.6097 9.02668 14.4232 9.12117 14.2286L9.8141 12.8313C10.1921 12.0731 10.8062 12.0731 11.1803 12.8313Z"
        stroke="#A2A2A2"
        stroke-width="0.967742"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default MedalIcon;
